/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitForm} from '../api'

export const useMutationSubmitForm = createReactQueryMutationHook('submitForm', submitForm)
